import axiosInstance from "@/api/axios";

// 공통 GET 함수
export async function fetchData(endpoint) {
  try {
    const response = await axiosInstance.get(endpoint);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${endpoint}:`, error);
    throw error;
  }
}

// 공통 POST 함수
export async function createData(endpoint, payload) {
  try {
    const response = await axiosInstance.post(endpoint, payload);
    return response.data;
  } catch (error) {
    console.error(`Error posting data to ${endpoint}:`, error);
    throw error;
  }
}

// 공통 PUT 함수
export async function updateData(endpoint, payload) {
  try {
    await axiosInstance.put(endpoint, payload);
  } catch (error) {
    console.error(`Error updating data at ${endpoint}:`, error);
    throw error;
  }
}

// 공통 DELETE 함수
export async function deleteData(endpoint) {
  try {
    await axiosInstance.delete(endpoint);
  } catch (error) {
    console.error(`Error deleting data at ${endpoint}:`, error);
    throw error;
  }
}

export default { fetchData, createData, updateData, deleteData };
